import { ClassForm } from "../components/class_form";
import Footer from "../components/footer";
import Header from "../components/header";
import t from "../locales";

export default function DashboardForm() {
  return (
    <>
      <title>{t("dashboard.title")}</title>
      <div className="page">
        <Header />
        <ClassForm />
        <Footer />
      </div>
    </>
  );
}
